/* tslint:disable:no-any */
type Entries<T> = Array<{ [K in keyof T]: [K, T[K]] }[keyof T]>;

const objectEntriesTyped = <T extends object>(v: T): Entries<T> => Object.entries(v) as any;

export default objectEntriesTyped;
